import { colors } from '../styles/colors';
import { ColorPalette } from '../types';

export const getColor = (color: string) => {
  if (['white', 'black'].includes(color)) {
    return colors.color[color].value as string;
  }
  const colorShadeMatch = color.match(/([a-z]+)(\d+)/);
  if (colorShadeMatch) {
    const [, colorName, shade] = colorShadeMatch;
    return (colors.color[colorName] as ColorPalette)[`${colorName}${shade}`]
      .value as string;
  } else {
    return '';
  }
};

export const getColorRGBA = (color: string, alpha: number) => {
  const hex = getColor(color);
  if (!hex) {
    return '';
  }
  const hexNumber = parseInt(hex.slice(1), 16);
  const r = (hexNumber >> 16) & 255;
  const g = (hexNumber >> 8) & 255;
  const b = hexNumber & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export default getColor;
